import { jsonObject, jsonArrayMember } from 'typedjson';
import { Invite } from './invite';

@jsonObject
export class InvitesResult {
  @jsonArrayMember(Invite)
  public data: Invite[];
}
